import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
// features
import CompensationGroupReport from '../../compensation-group';
import { visitCompensationGroupOnFleetProfilePage } from '../../compensation-group/actions';
// forms
import { FormGroupWrapper } from '../../../forms';
// feature fleet-profile
import { FormGroupTitle } from '../components/form-group-title';
//////////////////////////////////////////////////

const CompensationGroupFormGroupTable = (props) => {
  const {
    isOpened,
    groupName,
    isReadOnlyMode,
    formGroupTitleArr,
    primaryObjectGuid,
    primaryObjectGuidKey,
    handleToggleFormGroupTable,
  } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(visitCompensationGroupOnFleetProfilePage({ [primaryObjectGuidKey]: primaryObjectGuid }));
  }, []);

  return (
    <FormGroupWrapper isOpened={isOpened}>
      <FormGroupTitle
        groupName={groupName}
        withoutAddition={true}
        formGroupTitleArr={formGroupTitleArr}
        handleToggleFormGroupTable={handleToggleFormGroupTable}
      />
      <CompensationGroupReport
        pl='0px'
        maxHeight={400}
        height='max-content'
        customTitleComponent=' '
        isReadOnlyMode={isReadOnlyMode}
      />
    </FormGroupWrapper>
  );
};

export default CompensationGroupFormGroupTable;
